import { ManagedCampaignsRequiringUpdate } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const cancelableFetchManagedCampaignsRequiringUpdate = async (): Promise<ManagedCampaignsRequiringUpdate[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<ManagedCampaignsRequiringUpdate[]>(
        `social-campaigns/managed/managed-campaigns-requiring-update-report`,
    );

export const ManagedCampaignsRequiringUpdateGateway = {
    cancelableFetchManagedCampaignsRequiringUpdate,
};
